import { ASSETS_PATH } from "@/config";

function normalizePath(...parts: string[]) {
  return parts.join("/").replace(/\/+/g, "/");
}

export function getAsset(path: string) {
  return normalizePath(ASSETS_PATH, path);
}
